import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import {
  DescriptionText,
  MediumText,
} from 'src/global.styles/typography.styles'
import { UploadSVG, CloseSVG } from 'src/components/Icons/Basic'

export const CsvV2ModalSubtitle = styled.p`
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${palette.neutral[900]};
  line-height: 1.5;
  margin: 0 0 16px 0;
`

export const CsvV2PanelsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`

export const CsvV2Panel = styled.div`
  border: 1px solid ${palette.neutral[100]};
  border-radius: 8px;
  padding: 16px;
  min-height: 205px;
`

export const CsvV2SampleBox = styled(DescriptionText)`
  background: ${palette.neutral[30]};
  border-radius: 8px;
  color: ${palette.neutral[800]};
  font-family: 'Abhaya Libre', serif;
  font-size: 18px;
  line-height: 1.5;
  display: block;
  margin: 0;
  margin-top: 16px;
  padding: 16px 32px;
  text-align: center;
`

export const CsvV2DownloadTemplate = styled.button`
  background: transparent;
  border: none;
  color: ${palette.blue[500]};
  cursor: pointer;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  margin-top: 16px;
  padding: 0;
`

export const CsvV2UploadPanel = styled(CsvV2Panel)<{ $isDragActive: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;
  ${({ $isDragActive }) =>
    $isDragActive ? `border-color: ${palette.neutral[400]};` : ''}
`

export const CsvV2EmptyUploadState = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
`

export const CsvV2UploadIcon = styled(UploadSVG)`
  height: 40px;
  width: 40px;
`

export const CsvV2BrowseButton = styled.button`
  background: ${palette.neutral.white};
  border: 1px solid ${palette.neutral[900]};
  border-radius: 8px;
  color: ${palette.neutral[900]};
  cursor: pointer;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 16px;
`

export const CsvV2SupportedText = styled.p`
  color: ${palette.neutral[600]};
  font-family: Poppins, sans-serif;
  font-size: 12px;
  line-height: 21px;
  margin: 0;
`

export const CsvV2SelectedState = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  width: 100%;
`

export const CsvV2FileChip = styled.div`
  align-items: center;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 20px;
  background: ${palette.neutral.white};
  display: inline-flex;
  gap: 10px;
  justify-content: center;
  padding: 8px 8px 8px 12px;
`

export const CsvV2FileTypeIconWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  height: 24px;
  justify-content: center;
  width: 24px;
`

export const CsvV2FileNameText = styled(MediumText)`
  color: ${palette.neutral[500]};
  font-weight: 400;
  margin: 0;
  white-space: nowrap;
`

export const CsvV2ChipRemoveButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${palette.neutral[600]};
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 0;
`

export const CsvV2CloseIcon = styled(CloseSVG)`
  fill: ${palette.neutral[600]};
  height: 12px;
  width: 12px;
`

export const CsvV2SummaryText = styled.p`
  color: ${palette.neutral[900]};
  font-family: Poppins, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  text-align: center;
`

export const CsvV2SummaryValue = styled.span`
  font-weight: 600;
`

export const CsvV2ErrorList = styled.ul`
  color: ${palette.magenta[500]};
  margin: 0;
  padding-left: 18px;
  width: 100%;
`

export const CsvV2EmptyMessage = styled.p`
  color: ${palette.magenta[500]};
  font-family: Poppins, sans-serif;
  font-size: 12px;
  margin: 0;
`
